import React, { useState } from "react";
import "./style.css";
import "@fontsource-variable/open-sans";
import longhorizontal from "../../assets/longhorizontal.svg";
import longvertical from "../../assets/longvertical.svg";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

let rows;
export const OverviewTable = (props) => {
  const [loading, setLoading] = React.useState(true);
  console.log("hit table");
  rows = props.rows;
  console.log("OverviewTable : ",rows[0]);

  if (rows) {
    for (const element of rows) {
      element.postionOrder = element.position_no;
    }
    rows.sort((a, b) => a.niin - b.niin);
    console.log(rows);
  } else {
    setLoading(true);
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      fontSize: 16,
      padding: 12,
      fontFamily: "Open Sans variable, Helvetica",
      fontWeight: "medium",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
      padding: 10,
      fontFamily: "Open Sans variable, Helvetica",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f0f4f8",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#fbfcfe",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 1,
      borderColor: "#cdd7e1",
    },
  }));

  function createData(nsn, niin, nomenclature, postionOrder, rotation, level) {
    return { nsn, niin, nomenclature, postionOrder, rotation, level };
  }

  function roationImage(width, length){
    const numericWidth = parseFloat(width);
    const numericLength = parseFloat(length);
    if (numericWidth>=numericLength){
      return <img src={longhorizontal} className="checkmark" alt="check" />;
    } else {
      return <img src={longvertical} className="checkmark" alt="check" />;
    }
  }
  return (
    <div className="displayTable">
      <Paper sx={{ height:"100%" ,width: "100%", overflow: "scroll", overflowY: "scroll" }}>
        <TableContainer
          sx={{
            maxHeight: "calc(100vh - 400px)",
            width: "100%",
            display: "flex",
            overflow: "hidden",
            overflowY: "scroll",
          }}
          component={Paper}
        >
          <Table
            stickyHeader
            className="table"
            aria-label="customized table"
            width="100%"
            overflow="scroll"
          >
            <TableHead className="table-header">
              <TableRow>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  NSN
                </StyledTableCell>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  NIIN
                </StyledTableCell>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  Nomenclature
                </StyledTableCell>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  Postion Order
                </StyledTableCell>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  Placement Direction
                </StyledTableCell>
                <StyledTableCell
                  width="17%"
                  align="center"
                  align-self="stretch"
                  className="table-header-cell"
                >
                  Vertical Level
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <StyledTableRow key={row.niin}>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                    component="th"
                    scope="row"
                  >
                    {row.nsn}
                  </StyledTableCell>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                    component="th"
                    scope="row"
                  >
                    {row.niin}
                  </StyledTableCell>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                  >
                    {row.nomenclature}
                  </StyledTableCell>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                  >
                    {row.postionOrder}
                  </StyledTableCell>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                  >
                    {roationImage(row.width, row.length)}
                  </StyledTableCell>
                  <StyledTableCell
                    width="17%"
                    align="center"
                    align-self="stretch"
                  >
                    {row.level}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};
export default OverviewTable;
